import api from '@/services/api';
import { useQuery } from '@tanstack/react-query';

const useGetPaymentType = () => {
  return useQuery({
    queryKey: ['payment-type'],
    queryFn: () => api.paymentType.getPaymentType()
  });
};
export default useGetPaymentType;
